import { NeoModel, ValueObject } from '@singularsystems/neo-core';

@NeoModel
export default class ClientCriteria extends ValueObject {
    public clientName: string = "";
    public isDeleted: boolean = false
}